export const PortalID = {
  Loader: "loader",
  Modal: "modal-container",
  AppHeader: "app-header",
  Floaters: "floaters",
  UiWidgets: "ui-widgets",
  Tooltips: "tooltips",
  Comments: "comments",
  WalkthroughTips: "walkthrough-tips",
  Checkout: "checkout",
  ErrorPage: "error-page",
};
